import type { SxProps, Theme } from '@mui/material';

const dialogPaper: SxProps<Theme> = {
  borderRadius: '8px',
};

const dialogTitle: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: 16,
  py: 1.5,
};

const dialogContent: SxProps<Theme> = {
  py: 2,
};

export const styles = {
  dialogPaper,
  dialogTitle,
  dialogContent,
} as const;
